"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function CallToAction() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  return <section id="výzva-k-akci" className="dark bg-background text-foreground relative py-24 px-4 overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1543299/img/dark_gray_brushed_metal_texture.png)] opacity-40" />
      
      {}
      <div className="absolute inset-0 bg-gradient-to-b from-background/80 via-background/60 to-background/80" />

      {}
      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto text-center transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-display font-bold text-foreground leading-tight mb-6">
          Chraňte svou střechu profesionálně
        </h2>

        {}
        <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed">
          Zajistěte dlouhodobou ochranu, čistotu a energetickou nezávislost vaší nemovitosti. Kontaktujte nás ještě dnes.
        </p>

        {}
        <Link to="#kontakt">
          <Button size="lg" className="btn-primary text-base md:text-lg px-8 py-4 h-auto">
            Nezávazná kalkulace zdarma
          </Button>
        </Link>
      </div>
    </section>;
}